import React, { forwardRef, useState } from 'react'
import moment from "moment";
import ReactDOM from "react-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import TitleNames from '../../Component/Header/TitleNames'
import "react-datepicker/dist/react-datepicker.css";
import './Dashboard.css'
import { Link, useNavigate } from "react-router-dom";
import { PostAPI } from '../../common/Api';

const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (

    <div className="calendar">

        <button

            className="example-custom-input Lab_Restoration_input"

            onClick={onClick}

            ref={ref}

        >

            {value ? value : 'dd/mm/yyyy - dd/mm/yyyy'}

            {/*       <img classname="image" src={logistics} alt="icon" /> */}

        </button>

    </div>

))

const Dashboard = () => {
    const navigate = useNavigate();


    const tabDetails = [
        {
            id: 1,
            name: 'Today'
        },
        {
            id: 2,
            name: 'Yesterday'
        },
        {
            id: 3,
            name: 'Last 7 days'
        },
        {
            id: 4,
            name: 'Last 14 days'
        },
        {
            id: 5,
            name: 'MTD'
        },
        {
            id: 6,
            name: 'Custom Range',
        },

    ]
    if (sessionStorage.getItem('login_details')) {
        var user_id = JSON.parse(sessionStorage.getItem('login_details')).counsellor_id;
    } else {
        setTimeout(() => {
            navigate("/");
        }, 200)
    }
    const [dateRange, setDateRange] = useState([null, null])
    const [startDateRange, endDateRange] = dateRange

    const[toggle,setToggle]=useState('')
    const [dates, setDatesState] = useState({
        startDate: "",
        endDate: ""
    });

    const setDates = (e, { startDate, endDate }) => {
        // console.log(startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"))
        setDatesState({
            startDate: startDate.format("YYYY-MM-DD"),
            endDate: endDate.format("YYYY-MM-DD")
        });
        handleChange({ id: 6, name: 'daterange', startDate: startDate.format("YYYY-MM-DD"), endDate: endDate.format("YYYY-MM-DD") })
    };
    const ranges = {

    };


    const [selectDate, setSelectDate] = useState(false);
    const [queryData, setQueryData] = useState({
        total_query_answered: 0,
        total_query_handled: 0,
        total_query_pending: 0
    })
    const [itemVal, setItemVal] = useState('')
    const [itemRangeVal, setItemRangeVal] = useState('')
    const handleChange = (item) => {
        setItemVal(item?.id)
        // console.log("kh",item?.id)
        if (item.name == 'Custom Range') {
            setSelectDate(!selectDate)
        } else {
            let formData = new FormData();
            formData.append('id', user_id);
            formData.append('type', item.id);
            if (item.name == 'daterange') {
                setItemRangeVal('?start-date='+moment(item.startDate).format('YYYY-MM-DD')+'&end-date='+moment(item.endDate).format('YYYY-MM-DD'))
                formData.append('start_date',moment(item.startDate).format('YYYY-MM-DD'));
                formData.append('end_date', moment(item.endDate).format('YYYY-MM-DD'));
            }else{
                setItemRangeVal('');
            }
            var apiData = {
                url: 'counsellor_dashboard',
                data: formData
            }
            console.log('dates', dates)
            PostAPI(apiData, (res) => {
                console.log(res)
                if (res && res.status) {
                    if (item.id == 1) {
                        setQueryData({
                            total_query_answered: res.total_query_answered[0].today_user_query,
                            total_query_handled: res.total_query_handled[0].today_user_query,
                            total_query_pending: res.total_query_pending[0].today_user_query
                        })
                    } else if (item.id == 2) {
                        setQueryData({
                            total_query_answered: res.total_query_answered[0].yesterday_user_query,
                            total_query_handled: res.total_query_handled[0].yesterday_user_query,
                            total_query_pending: res.total_query_pending[0].yesterday_user_query
                        })
                    } else if (item.id == 3) {
                        setQueryData({
                            total_query_answered: res.total_query_answered[0].past_7days_user_query,
                            total_query_handled: res.total_query_handled[0].past_7days_user_query,
                            total_query_pending: res.total_query_pending[0].past_7days_user_query
                        })
                    } else if (item.id == 4) {
                        setQueryData({
                            total_query_answered: res.total_query_answered[0].past_14days_user_query,
                            total_query_handled: res.total_query_handled[0].past_14days_user_query,
                            total_query_pending: res.total_query_pending[0].past_14days_user_query
                        })
                    } else if (item.id == 5) {
                        setQueryData({
                            total_query_answered: res.total_query_answered[0].monthly_user_query,
                            total_query_handled: res.total_query_handled[0].monthly_user_query,
                            total_query_pending: res.total_query_pending[0].monthly_user_query
                        })
                    } else if (item.id == 6) {
                        setQueryData({
                            total_query_answered: res.total_query_answered[0].custom_user_query,
                            total_query_handled: res.total_query_handled[0].custom_user_query,
                            total_query_pending: res.total_query_pending[0].custom_user_query
                        })
                    }
                } else {
                    // toast.error(res.message)
                }
            })
        }

    }
    console.log('itemRangeVal',itemRangeVal)

   
    return (
        <>
            <TitleNames />

            <div className='container dashboard-container'>
                <div>
                    <div className='card-box'>
                        <div className='DashboardContent'><h5 className='card-title LaiAsk'>Ask LAIQA - Dashboard</h5></div>

                        <div className='card-body'>

                            <div className='row'>
                                <div className='col-lg-12'>
                                    <ul class="nav nav-pills navBar ">
                                        {tabDetails.map((item) => {
                                            return (<li className="nav-item navBar-list" onClick={() => handleChange(item)} >
                                                <button className='btn btn-secondary'>
                                                    <a className="nav-link" >{item.name}</a>
                                                </button>
                                            </li>)
                                        })}

                                    </ul>
                                </div>
                                {selectDate &&
                                    <DateRangePicker
                                        onApply={setDates}
                                        initialSettings={{ startDate: '08/20/2022', endDate: '08/28/2022', ranges: ranges }}
                                        className=""

                                    >
                                        <input
                                            name=""
                                            value={dates.startDate + "" + "" + "-" + "" + "" + dates.endDate}
                                            className="CustomDtae"

                                        />

                                    </DateRangePicker>
                                }
                            </div>

                        </div>

                    </div>
                </div>
                <div className='row result-data'>
                    <div className=' col-lg-3'>
                        <Link to={`/querylist/${itemVal}/query_responded${itemRangeVal}`} className='DetalsList' >
                            <div className='result-container'>
                                <h2>{queryData.total_query_answered}</h2>
                                <span>
                                    Total Queries Answered
                                </span>
                            </div>
                        </Link>

                    </div>
                    <div className=' col-lg-3'>
                        <Link to={`/querylist/${itemVal}/total_query_handled${itemRangeVal}`} className='DetalsList' >
                            <div className='result-container'>
                                <h2>{queryData.total_query_handled}</h2>
                                <span>
                                    Total Queries Handled
                                </span>
                            </div>
                        </Link>

                    </div>
                    <div className=' col-lg-3'>
                        <Link to={`/querylist/${itemVal}/query_pending${itemRangeVal}`} className='DetalsList' >
                            <div className='result-container'>
                                <h2>{queryData.total_query_pending}</h2>
                                <span>
                                    Total Queries Pending
                                </span>
                            </div>
                        </Link>

                    </div>
                    <div className=' col-lg-3'>
                        <Link to="/querylist" className='DetalsList'>
                            <div className='result-container'>
                                <h2>0</h2>
                                <span>
                                    Callback scheduled
                                </span>
                            </div>
                        </Link>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Dashboard